import React from "react";
import styled from "styled-components";
import { Radius, Spacing, content, dominant } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import CardViz from "@radarly/components/panels/card-library/card";
import { tr } from "@radarly/i18n";
import { PastedCard } from "@radarly/models/insight-pages/editor";

interface IProps {
  cards: PastedCard[];
  onSelect: (index: number) => void;
  locale: Locale;
  selectedIndex: number;
}

const Text = styled.p`
  color: ${(props) => content(props, "secondary")};
`;

const Cards = styled.div`
  display: flex;
`;

const CardButton = styled.button<{ isActive: boolean }>`
  text-align: left;
  margin: 12px 0;
  border-radius: ${Radius.MediumLarge};
  border: 2px solid;
  background: transparent;
  cursor: pointer;
  border-color: ${(props) =>
    props.isActive ? dominant(props) : "transparent"};
  padding: ${Spacing.Medium};
`;

export default function PastedCards({
  cards,
  onSelect,
  locale,
  selectedIndex,
}: IProps) {
  return cards.length > 0 ? (
    <div>
      <Text>{tr(locale, "INSIGHT_PAGE_CARD_COPIED_TEXT")}</Text>
      <Cards>
        {cards.map((card, i) => (
          <CardButton key={i} isActive={i === selectedIndex}>
            <CardViz
              viz={card.dataviz.name}
              title={card.title}
              onClick={() => onSelect(i)}
              vizOptions={card.vizOptions}
              color={card.color}
            />
          </CardButton>
        ))}
      </Cards>
    </div>
  ) : (
    <div>
      <Text>{tr(locale, "INSIGHT_PAGE_NO_CARD_COPIED_TEXT")}</Text>
    </div>
  );
}
